// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-photoprintsdropzone_default__rl-es"};